import script from "./WrybitBoundary.vue?vue&type=script&setup=true&lang=ts"
export * from "./WrybitBoundary.vue?vue&type=script&setup=true&lang=ts"

import "./WrybitBoundary.vue?vue&type=style&index=0&id=358caf14&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-358caf14"]])

export default __exports__